<div class="card">
	<div class="card-header border-0 pt-6">
		<div class="card-title">
			<div class="d-flex align-items-center position-relative my-1">
				<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
					<span class="path1"></span>
					<span class="path2"></span>
				</i>
				<input type="text" data-table-filter="search" class="form-control form-control-sm w-250px ps-12" placeholder="Search" />
			</div>
		</div>
		<div class="card-toolbar">
			<div class="d-flex justify-content-end" data-table-toolbar="base">
				<button type="button" class="btn btn-sm btn-dark fw-bold d-flex me-3"
					[class.active]="showFilters"
					(click)="toggleFilters()">
					<i class="ki-duotone ki-filter fs-6 text-muted me-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Filter</span>
				</button>
				<button type="button" class="btn btn-sm btn-dark me-3 text-nowrap" (click)="openAddDepositModal()">
					<i class="ki-duotone ki-plus fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Add Deposit</span>
				</button>
				<button type="button" class="btn btn-sm btn-primary me-3 text-nowrap" data-bs-toggle="modal" data-bs-target="#kt_export_modal">
					<i class="ki-duotone ki-exit-up fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Export</span>
				</button>
				<a href="#" class="btn btn-sm btn-dark me-3 text-nowrap">
					<i class="ki-duotone ki-cloud-download fs-2">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
					<span>Download</span>
				</a>
				<div class="w-100 mw-150px">
					<select class="form-select form-select-sm" data-hide-search="true" data-placeholder="Status" data-table-filter="status">
						<option value="" selected disabled>Status</option>
						<option value="all">All</option>
						<option value="Complete">Complete</option>
						<option value="Pending">Pending</option>
					</select>
				</div>
			</div>
			<div class="d-flex justify-content-end align-items-center d-none" data-table-toolbar="selected">
				<div class="fw-bold me-5">
					<span class="me-2" data-table-select="selected_count"></span>Selected
				</div>
				<button type="button" class="btn btn-sm btn-dark" data-table-select="delete_selected">Delete Selected</button>
			</div>
		</div>
	</div>

	<!-- Filters Section -->
	<div class="card-body border-bottom py-4 deposit-filters" *ngIf="showFilters" [@slideInOut]>
		<div class="row g-4">
			<!-- Keyword -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Keyword</label>
				<input
					type="text"
					class="form-control form-control-sm"
					placeholder="Enter keyword..."
					[(ngModel)]="filters.keyword">
			</div>

			<!-- Email -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Email</label>
				<input
					type="text"
					class="form-control form-control-sm"
					placeholder="Enter email..."
					[(ngModel)]="filters.email">
			</div>

			<!-- Payment Status -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Payment</label>
				<div class="d-flex gap-3">
					<div class="form-check form-check-sm">
						<input class="form-check-input" type="radio" name="payment" id="payment_complete" value="Complete" [(ngModel)]="filters.payment">
						<label class="form-check-label fs-7" for="payment_complete">Complete</label>
					</div>
					<div class="form-check form-check-sm">
						<input class="form-check-input" type="radio" name="payment" id="payment_pending" value="Pending" [(ngModel)]="filters.payment">
						<label class="form-check-label fs-7" for="payment_pending">Pending</label>
					</div>
					<div class="form-check form-check-sm">
						<input class="form-check-input" type="radio" name="payment" id="payment_all" value="All" [(ngModel)]="filters.payment">
						<label class="form-check-label fs-7" for="payment_all">All</label>
					</div>
				</div>
			</div>

			<!-- Date Range -->
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Received Date From</label>
				<input
					type="date"
					class="form-control form-control-sm"
					[(ngModel)]="filters.received_date_from">
			</div>
		</div>

		<div class="row g-4 mt-2">
			<div class="col-md-3">
				<label class="form-label fw-semibold text-gray-600 fs-7">Received Date To</label>
				<input
					type="date"
					class="form-control form-control-sm"
					[(ngModel)]="filters.received_date_to">
			</div>

			<!-- Filter Actions -->
			<div class="col-md-9 d-flex align-items-end justify-content-end">
				<div class="d-flex gap-2">
					<button type="button" class="btn btn-sm btn-primary" (click)="applyFilters()">
						<i class="ki-duotone ki-magnifier fs-3">
							<span class="path1"></span>
							<span class="path2"></span>
						</i>
						Apply Filters
					</button>
					<button type="button" class="btn btn-sm btn-secondary" (click)="resetFilters()">
						<i class="ki-duotone ki-cross fs-3">
							<span class="path1"></span>
							<span class="path2"></span>
						</i>
						Reset
					</button>
				</div>
			</div>
		</div>
	</div>

	<div class="card-body pt-0">
		<!-- Loading State -->
		<div *ngIf="isLoading" class="d-flex justify-content-center align-items-center py-10">
			<span class="spinner-border spinner-border-sm me-2"></span>
			Loading deposits...
		</div>

		<!-- No Data State -->
		<div *ngIf="!isLoading && deposits.length === 0" class="text-center py-10 text-muted">
			No deposits found
		</div>

		<!-- Deposit Table with Sticky Column -->
		<div *ngIf="!isLoading && deposits.length > 0" class="deposit-table-container">
			<div class="table-responsive">
				<table class="table table-row-bordered table-row-gray-100 align-middle gs-0 gy-3 deposit-table" id="kt_table_manage_deposits">
					<thead>
						<tr class="fw-bold text-muted bg-primary-subtle">
							<!-- Sticky Column: Checkbox + Ref # -->
							<th class="sticky-column min-w-200px">
								<div class="d-flex align-items-center">
									<div class="form-check form-check-sm form-check-custom form-check-solid me-3">
										<input class="form-check-input" type="checkbox" data-kt-check="true" data-kt-check-target="#kt_table_manage_deposits .invoice-number-check" value="1" />
									</div>
									Ref. #
								</div>
							</th>
							<!-- Scrollable Columns -->
							<th class="min-w-120px">Received Date</th>
							<th class="min-w-200px">Customer Name</th>
							<th class="min-w-150px">Bank Name</th>
							<th class="min-w-150px">Depositor</th>
							<th class="min-w-120px">Chassis #</th>
							<th class="min-w-150px">User Name</th>
							<th class="min-w-120px">Ref. Date</th>
							<th class="min-w-120px text-end">Total Amount</th>
							<th class="min-w-100px text-end">Ex. Rate</th>
							<th class="min-w-120px text-end">Allocated</th>
							<th class="min-w-120px text-end">Available</th>
							<th class="min-w-100px">Mode</th>
							<th class="min-w-200px">Admin Comment</th>
							<th class="min-w-150px">Agent Name</th>
							<th class="min-w-80px">Docs</th>
							<th class="min-w-120px">Confirm Payment</th>
							<th class="min-w-120px">Actions</th>
						</tr>
					</thead>
					<tbody class="text-gray-600 fw-semibold">

						<tr *ngFor="let deposit of deposits; trackBy: trackByDepositId" class="cursor-pointer">
							<!-- Sticky Column: Checkbox + Ref # -->
							<td class="sticky-column">
								<div class="d-flex align-items-center">
									<div class="form-check form-check-sm form-check-custom form-check-solid me-3">
										<input class="form-check-input invoice-number-check" type="checkbox" [value]="deposit._id" />
									</div>
									<span class="fw-bold text-primary">{{ deposit.reference_number || '-' }}</span>
								</div>
							</td>
							<!-- Scrollable Columns -->
							<td class="text-nowrap">{{ deposit.received_date | dateFormat }}</td>
							<td class="text-nowrap w-150px">
								<div class="customer-hover-container">
									<button type="button" class="btn btn-link p-0 text-start"
										(click)="openClientAccountModal(deposit.customer_id || deposit.customer?._id)"
										[disabled]="!deposit.customer_id && !deposit.customer?._id">
										{{ deposit.customer?.name || '-' }}<br>[{{ deposit.customer?.company || '-' }}, {{ deposit.customer?.country || '-' }}]
									</button>
								</div>
							</td>
							<td class="text-nowrap">{{ deposit.bank || '-' }}</td>
							<td class="text-nowrap">{{ deposit.depositor_name || '-' }}</td>
							<td class="text-nowrap">{{ deposit.chassis_no || '--' }}</td>
							<td class="text-nowrap">{{ deposit.customer?.sales_person || '-' }}</td>
							<td class="text-nowrap">{{ deposit.received_date | dateFormat }}</td>
							<td class="text-nowrap text-end">{{ deposit.received_amount | currencyFormat:(deposit.customer?.currency_type || 'USD') }}</td>
							<td class="text-nowrap text-end">{{ deposit.ex_rate }}</td>
							<td class="text-nowrap text-end">{{ deposit.amount_allocated | currencyFormat:(deposit.customer?.currency_type || 'USD') }}</td>
							<td class="text-nowrap text-end">{{ deposit.remaining_amount | currencyFormat:(deposit.customer?.currency_type || 'USD') }}</td>
							<td class="text-nowrap">{{ deposit.payment_type || '-' }}</td>
							<td class="text-nowrap">{{ deposit.admin_comment || '-' }}</td>
							<td class="text-nowrap">{{ deposit.customer?.sales_person || '-' }}</td>
							<td class="text-nowrap text-center">
								<a href="#" *ngIf="deposit.doc_id">
									<i class="ki-duotone ki-document fs-1 text-gray-800 text-hover-primary">
										<span class="path1"></span>
										<span class="path2"></span>
									</i>
								</a>
								<span *ngIf="!deposit.doc_id">-</span>
							</td>
							<td class="text-nowrap text-end">
								<div class="form-check form-check-sm form-check-custom form-check-solid">
									<input class="form-check-input" type="checkbox" [value]="deposit._id" />
								</div>
							</td>
							<td class="text-nowrap">
								<div class="d-flex gap-2">
									<button type="button"
											class="btn btn-icon btn-active-light-primary w-30px h-30px"
											title="Allocate"
											[routerLink]="['/sales/sales-payment/allocation', deposit.customer_id]"
											(click)="$event.stopPropagation()">
										<i class="ki-duotone ki-dollar fs-3">
											<span class="path1"></span>
											<span class="path2"></span>
											<span class="path3"></span>
										</i>
									</button>
									<button type="button"
											class="btn btn-icon btn-active-light-primary w-30px h-30px"
											title="Edit"
											(click)="openEditDepositModal(deposit); $event.stopPropagation()">
										<i class="ki-duotone ki-pencil fs-3">
											<span class="path1"></span>
											<span class="path2"></span>
										</i>
									</button>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>

		<!-- Pagination -->
		<app-pagination
			*ngIf="!isLoading && deposits.length > 0"
			[paginationInfo]="paginationInfo"
			[loading]="isLoading"
			(pageChange)="onPageChange($event)">
		</app-pagination>
	</div>
</div>

<app-sales-payment-client-account-modal></app-sales-payment-client-account-modal>

<app-add-update-deposit (depositAdded)="onDepositAdded()" (depositUpdated)="onDepositUpdated()"></app-add-update-deposit>
